<template>

  <div class="notification_triggers">

    <trigger-item
      ref="triggers_list"
      v-for="(trigger, key) in this.notification.triggers"
      :key="key"
      :trigger_key="key"
      :trigger="trigger"
      :option="option"
      :elements.sync="elements"
      @delTrigger="delete_trigger"
    />

    <div class="new_trigger" @click="add_trigger()" v-if="this.option.length > 0">
      <span class="mdi mdi-plus-box"/>
      <span class="title">
        {{this.translate('notification.edit.triggers.new_trigger')}}
      </span>
    </div>

  </div>

</template>

<script>
import TriggerItem from "./TriggerItem";

export default {
  name: "notification-trigger",
  components: {
     TriggerItem
  },
  props: ['notification'],

  data () {
    return {
      triggers_list: []
    }
  },
  computed: {
    option () {
      return this.getOpt()
    },
    elements () {
      return this.get_elements()
    }
  },
  created(){
    this.get_triggers_list()
  },
  methods : {
    translate_name(val){
      return this.translate(val)
    },

    getOpt () {
      let option = []
      let tempOpt = {...this.triggers_list}
      let raw = {}

      for (let i in tempOpt) {
        if(raw[tempOpt[i].block_triggers] === undefined) {
          raw[tempOpt[i].block_triggers] = []
        }
        raw[tempOpt[i].block_triggers].push(tempOpt[i])
      }

      var subTmp = []
      for(let i in raw) {
        subTmp = []
        for (let j in raw[i]) {
          subTmp.push(raw[i][j])
        }
        option.push(
          {
            id: i,
            label: i,
            children: [...subTmp]
          }
        )
      }

      return option
    },

    add_trigger(){
      let new_trigger = {
        definition_id: this.option[0].children[0].id,
        label: '',
        type: '',
        time: true,
        units: '',
        url: '',
        params:{
          normal: 0,
          crit: 0,
          timer: 0
        },
        block_devices: '',
        block_triggers: '',
        list: []
      }
      this.notification.triggers.push(new_trigger)
    },

    get_triggers_list(){
      if (this.notification.devices.length === 1 && this.notification.groups.length < 1) {
        this.notification.valid_trigger_block = 'device'
      } else {
        this.notification.valid_trigger_block = 'group'
      }

      if (this.notification.valid_trigger_block !== ''){
        this.$http.v1.getTriggersList({valid_for: this.notification.valid_trigger_block}, (response) => {

          let triggers_list = this.triggers_as_array(response.data.all, 'all')
          if (response.data.device) triggers_list = triggers_list.concat(this.triggers_as_array(response.data.device, 'device'))
          if (response.data.group) triggers_list = triggers_list.concat(this.triggers_as_array(response.data.group, 'group'))

          this.triggers_list = triggers_list

          if (this.notification.triggers.length > 0) {
            for (let tr in this.notification.triggers) {
              for (var trl in this.triggers_list) {
                if (this.triggers_list[trl].id === this.notification.triggers[tr].definition_id) {
                  this.notification.triggers[tr].label = this.triggers_list[trl].label
                  this.notification.triggers[tr].url = this.triggers_list[trl].url
                  this.notification.triggers[tr].block_devices = this.triggers_list[trl].block_devices
                  this.notification.triggers[tr].block_triggers = this.triggers_list[trl].block_triggers
                }
              }
            }
          }
        })
      }
    },

    get_elements(){
      let list_elements = {}
      for (let tr of this.triggers_list) {
        if (tr.type === 'list') {
          this.$http.v1.getNotificationInterfaces({device_ids:this.notification.devices, group_ids: this.notification.groups}, (response) => {
            if (!response.data.status){
              let array = []
              for (let i in response.data) {
                array.push({label: response.data[i].id, id: response.data[i].id})
              }
              list_elements[tr.url] = array
            }
          })
        }
      }
      return list_elements
    },

    triggers_as_array(array_triggers, type){
      let triggers_list = []

      for (let at in array_triggers) {
        let params = JSON.parse(array_triggers[at].ui_params)
        let trigger = {
          label: '',
          block_devices: type,
          id: array_triggers[at].id,
          block_triggers: params.block,
          time: params.time,
          type: params.type,
          units: params.units,
          max: params.max,
          min: params.min,
          url: params.url
        }

        if(this.$data.language === "ru" && params.name_ru) {
          trigger.label = params.name_ru
        }else if (this.$data.language === "en" && params.name_en) {
          trigger.label = params.name_en
        }

        if(trigger.label === '') {
          trigger.label = array_triggers[at].name
        }

        triggers_list.push(trigger)
      }
      return triggers_list
    },

    delete_trigger(key){
      this.notification.triggers.splice(key,1)
    }
  }

}
</script>

<style lang="scss">
.notification_triggers{
  overflow: auto;
  margin-top: 0;
  height: 100%;
  padding: 10px;

  .new_trigger{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 10px;
    padding: 10px;
    background: #41b8831f;
    border: 1px dashed #41B883;
    transition: 0.2s;
    .mdi{
      font-size: 25px
    }
    &:hover{
      background: #41b8835e;
    }
  }
}

@media (max-width: 700px) {
  .notification_triggers{
    .trigger{
      flex-wrap: wrap;
      .select{
        width: 100%;
        margin-bottom: 20px;
      }
      .params{
        width: 100%;
        margin-bottom: 20px;
      }
      .timer{
        width: 100%;
        margin-bottom: 20px;
      }
      .delete{
        display: flex;
        justify-content: center;
        width: 100%;
      }
    }
  }
}

</style>
